<i class="fa-duotone fa-solid fa-building-user"></i>

<div class="tenant-info">
  <div>
    <span class="tenant-name">{{ tenant.clientName }}</span>
    <span class="tenant-description">{{ tenant.clientDescription }}</span>
  </div>
  <span class="tenant-id">{{ tenant.id }}</span>
</div>
